/**
 * Org-role access policy shared by the route guard (RequiresAuth) and the
 * sidebar (MenuBar), so both always agree on who may see a gated page.
 *
 * Access is granted when `requiredOrgRoles` is empty, when the user is a
 * platform superuser, or when the user holds ANY of the required roles in the
 * currently selected organization (see UserOrgContext.hasRoleInSelectedOrg).
 *
 * @param {{ isSuperUser?: boolean, hasRoleInSelectedOrg?: (role: string) => boolean }} ctx
 * @param {string[]|undefined} requiredOrgRoles
 * @returns {boolean}
 */
export const hasAnyOrgRole = ({ isSuperUser, hasRoleInSelectedOrg }, requiredOrgRoles) => {
  if (!requiredOrgRoles || requiredOrgRoles.length === 0) return true;
  if (isSuperUser) return true;
  if (typeof hasRoleInSelectedOrg !== "function") return false;
  return requiredOrgRoles.some((role) => hasRoleInSelectedOrg(role));
};
